import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const Testimonials = () => {
  useEffect(() => {
    document.title = 'Testimonials | Diamond Club Matchmaking';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Hear what our clients are saying about the Diamond Club Matchmaking experience.");
    }
  }, []);

  return (
    <Layout>
      <section className="min-h-screen bg-black-deep grain-overlay">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          {/* Page Header */}
          <div className="text-center mb-12" data-testid="testimonials-header">
            <h1 className="font-serif text-display-sm md:text-display text-cream mb-4">
              Testimonials
            </h1>
            <p className="font-sans text-cream-muted text-base md:text-lg max-w-2xl mx-auto">
              Here's what our client's are saying about the Diamond Club
            </p>
          </div>

          {/* Video Embed */}
          <div className="max-w-3xl mx-auto" data-testid="testimonials-video">
            <div className="relative w-full aspect-video rounded-sm overflow-hidden border border-gold/20">
              <iframe
                src="https://www.youtube-nocookie.com/embed/EOOZ2kRWrwI?rel=0&modestbranding=1&showinfo=0"
                title="Diamond Club Matchmaking Testimonials"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Testimonials;
